export * from './lib/softline/hagebau-partner-softline.config';
export * from './lib/portal/hagebau-partner-portal.config';
